import styled from "styled-components";
import { switchProp, prop } from "styled-tools";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const ContentWrapper = styled.div`
    max-width: ${({maxwidth}) => (maxwidth ? maxwidth : "85%")};
    
    

	${media.lessThan(breakpoints.mobile)`
        max-width: 100%;
    `}
`;
